import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import NumericInput from 'components/common/numeric_input';

export const ConfigurationContainer = styled.div`
  align-items: center;
  display: flex;
  padding-bottom: 12px;
`;

export const ConfigurationHeader = styled.div`
  display: flex;
  margin-right: 12px;
  width: 300px;
`;

export const ConfigurationNumericInput = styled(NumericInput)`
  border: 1px solid ${p => p.theme.colors.gray400};
  height: 30px;
  margin-left: 12px;
  outline: none;
  padding-left: 6px;
  width: 30px;
  &:hover {
    border: 1px solid ${p => p.theme.colors.green400};
  }
`;

export const ConfigurationSection = styled.div`
  padding-bottom: 10px;
`;

export const LabelContainer = styled.div`
  padding-right: 7px;
`;

export const TooltipIcon = styled(FontAwesomeIcon)`
  color: ${p => p.theme.colors.gray600};
  cursor: pointer;
`;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/admin/channels/config_components.jsx